<template>
  <div class="userinformationcomponent">
    <span class="userinformationcomponent-title">{{ title }}</span>
    <code
      @mouseenter="mouseIn = true"
      @mouseleave="mouseIn = false"
      class="userinformationcomponent-content"
    >
      {{ content }}
      <i
        @click="copyContent"
        class="fa-regular fa-copy userinformationcomponent-content-btn-style"
        :class="{
          'userinformationcomponent-content-btn-active': mouseIn == true,
          'userinformationcomponent-content-btn': mouseIn == false
        }"
      ></i>
    </code>
  </div>
</template>
<script>
import router from '../router/index.js'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import FloatLabel from 'primevue/floatlabel'
import InputSwitch from 'primevue/inputswitch'
import CreateUserDialog from './CreateUserDialog.vue'
import ConfirmPopup from 'primevue/confirmpopup'
import { RouterLink, useRouter } from 'vue-router'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import axios from 'axios'
import { config } from '../assets/config.js'
import { useClipboard } from '@vueuse/core'

export default {
  components: {
    Dialog,
    Button,
    FloatLabel,
    InputText,
    InputSwitch,
    ConfirmPopup
  },

  props: {
    title: String,
    content: String
  },

  data() {
    return {
      mouseIn: false
    }
  },

  methods: {
    copyContent() {
      navigator.clipboard.writeText(this.$props.content)

      this.$toast.add({
        group: "tc",
        severity: "info",
        summary: "Kopiert!",
        life: 3000,
        closable: true,
        detail: "Der Text wurde in die Zwischenablage kopiert."
      })
    }
  },

  async mounted() {}
}
</script>
<style lang="scss" scoped>
.userinformationcomponent {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  position: relative;

  &-title {
    font-size: 1rem;
    font-weight: 700;
  }

  &-content-btn-style {
    position: absolute;
    transform: translate(50%, 50%);
    top: 1.5rem;
    right: 1rem;

    font-size: 1rem;

    opacity: 0;

    transition: opacity 0.3s, transform 0.2s;
  }

  &-content-btn-active {
    opacity: 0.6;
  }

  &-content-btn-active:hover {
    opacity: 1;
    transform: translate(50%, 50%) scale(1.3);
  }
}
</style>
